import { Injectable } from '@angular/core';
import { QrPosterRenderContext } from '../models/qr-poster-template.model';
import {
  PreparedQrPosterAssets,
  QrPosterRenderDescriptor,
} from '../models/qr-poster-render-descriptor.model';

@Injectable({ providedIn: 'root' })
export class QrPosterRenderContextBuilderService {
  build(
    descriptor: QrPosterRenderDescriptor,
    assets: PreparedQrPosterAssets,
    qrDataUrl: string,
  ): QrPosterRenderContext {
    return {
      companyName: descriptor.branding.companyName,
      companyDisplayEmail: descriptor.branding.companyDisplayEmail,
      companyPhone: descriptor.branding.companyPhone,
      companyWebsite: descriptor.branding.companyWebsite,
      companyAddress: descriptor.branding.companyAddress,
      companyLogoBase64: assets.logoBase64,
      propertyAddress: descriptor.property.propertyAddress,
      qrTargetUrl: descriptor.qrDestination,
      qrDataUrl,
      themeColor: descriptor.branding.themeColor,
      posterTexts: descriptor.posterTexts,
      icons: assets.icons,
      appMode: 'emergency',
    };
  }
}
